import { IField, IOption } from "./constants";
import { EMPTY_STRING } from "common/constants";

import { ParsableDate } from "@material-ui/pickers/constants/prop-types";

export const DIVIDER = ", ";

export const getMultiselectPreviewString = (
  selected: string[],
  options: IOption[]
): string => {
  if (!selected.length) {
    return EMPTY_STRING;
  }

  const allMappedOptions = options.reduce((acc, cur) => {
    if (cur.options.length) {
      cur.options.forEach(option => {
        acc[option.id] = option;
      });
    }
    acc[cur.id] = cur;
    return acc;
  }, {});
  const mainTrackId = Object.values(allMappedOptions).find(
    (item: IOption) => item.options
  )["id"];

  if (mainTrackId) {
    selected = [mainTrackId, ...selected.filter(item => item !== mainTrackId)];
  }

  return selected
    .map(selectedOptionId => allMappedOptions[selectedOptionId].name)
    .join(DIVIDER)
    .toLowerCase();
};

export const getInitialFocusedDate = (
  value: ParsableDate,
  field: IField
): ParsableDate => {
  if (value) return value;

  return field.initialFocusedDate || field.min;
};
